import { render, staticRenderFns } from "./imgR.vue?vue&type=template&id=77daa96b&scoped=true"
var script = {}
import style0 from "./imgR.vue?vue&type=style&index=0&id=77daa96b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77daa96b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77daa96b')) {
      api.createRecord('77daa96b', component.options)
    } else {
      api.reload('77daa96b', component.options)
    }
    module.hot.accept("./imgR.vue?vue&type=template&id=77daa96b&scoped=true", function () {
      api.rerender('77daa96b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgR.vue"
export default component.exports